import type { Question, QuestionOption } from '@/types/knowledge.js'

export function normalizeAnswers(values: readonly string[]): string[] {
  return [...new Set(values.filter(Boolean))].sort()
}

export function isAnswerCorrect(question: Question, selectedAnswers: readonly string[]): boolean {
  const expected = normalizeAnswers(question.answer)
  const selected = normalizeAnswers(selectedAnswers)
  return (
    expected.length === selected.length && expected.every((key, index) => key === selected[index])
  )
}

export function getQuestionOptions(question: Question): readonly QuestionOption[] {
  if (question.options.length) return question.options
  if (question.type === 'judge') {
    return [
      { key: 'true', text: '正确' },
      { key: 'false', text: '错误' },
    ]
  }
  return []
}

export function getAnswerText(question: Question, answers: readonly string[]): string[] {
  const options = getQuestionOptions(question)
  return normalizeAnswers(answers).map((key) => {
    const option = options.find((candidate) => candidate.key === key)
    return option ? `${option.key}. ${option.text}` : key
  })
}

export function getQuestionTypeLabel(type: Question['type']): string {
  if (type === 'multiple') return '多选题'
  if (type === 'judge') return '判断题'
  return '单选题'
}
